import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=be21d5b2&scoped=true"
import script from "./Scrollable.vue?vue&type=script&lang=js"
export * from "./Scrollable.vue?vue&type=script&lang=js"
import style0 from "./Scrollable.vue?vue&type=style&index=0&id=be21d5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be21d5b2",
  null
  
)

export default component.exports